<template>
  <div
    class="main-image"
    :class="!url && 'none-image'"
    :style="backgroundImageFromApi(url)"
  />
</template>

<script>
export default {
  name: "TheCouponImage",
  props: {
    url: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.main-image {
  position: relative;
  background-color: #f0f0f0;
  height: 260px;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;

  &.none-image {
    height: 80px;
    background-color: white;
  }
}
</style>
